import React from 'react';
import ExternalHeader from './ExternalHeader';
import ExternalSidebar from './ExternalSidebar';

interface ExternalLayoutProps {
  children: React.ReactNode;
}

const ExternalLayout: React.FC<ExternalLayoutProps> = ({ children }) => (
  <div className="h-screen min-w-0 overflow-hidden bg-gray-50">
    <div className="flex h-screen min-h-0">
      <ExternalSidebar />
      <div className="flex min-h-0 min-w-0 flex-1 flex-col">
        <ExternalHeader />
        <main className="min-h-0 flex-1 overflow-hidden">
          <div className="mx-auto h-full min-h-0 w-full max-w-7xl overflow-hidden bg-white px-3 py-4 sm:px-5 sm:py-5 lg:px-7 lg:py-6">
            {children}
          </div>
        </main>
      </div>
    </div>
  </div>
);

export default ExternalLayout;